<div class="simplified-automation-editor">
  <mat-accordion class="task-definition-groups" multi="true" displayMode="flat">
    <mat-expansion-panel hideToggle disabled>
      <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
        <div class="automation-header">
          <div class="automation-header-row">
            <div class="automation-details">
              <h2>{{ automationName() }}</h2>
            </div>
            <div class="advanced-editor-actions">
              <mat-slide-toggle (change)="toggleAdvancedMode()" [checked]="isAdvancedMode()">
                {{ 'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.ADVANCED_MODE' | translate }}
              </mat-slide-toggle>
              @if (isAutomationDraining()) {
                <button mat-stroked-button (click)="stopDraining()">
                  {{ 'AUTOMATIONS.COMMON.STOP_DRAINING' | translate }}
                </button>
              } @else {
                <mat-slide-toggle [formControl]="automationRunStateControl" (change)="onToggleChange($event)">
                  @if (automationRunStateControl.value) {
                    {{ 'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.ON' | translate }}
                  } @else {
                    {{ 'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.OFF' | translate }}
                  }
                </mat-slide-toggle>
              }
              <button mat-icon-button [matMenuTriggerFor]="menuRef">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menuRef>
                <button
                  mat-menu-item
                  data-action="simplified-editor-clicked-edit-details"
                  (click)="emitAutomationEditDetailsEvent()"
                >
                  {{ 'AUTOMATIONS.COMMON.EDIT_DETAILS' | translate }}
                </button>
              </mat-menu>
            </div>
          </div>
          @if (!isAdvancedMode() && workflowData().unableToLoadData) {
            <glxy-alert type="warning">
              {{ 'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.UNABLE_TO_LOAD_AUTOMATION_DATA' | translate }}
            </glxy-alert>
          }
          @if (hasErrors()) {
            <div class="automation-header-row">
              <glxy-alert type="error" class="automation-errors">
                {{ 'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.ERRORS_MESSAGE' | translate }}
              </glxy-alert>
            </div>
          }
        </div>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    @if (!isAdvancedMode() && taskDefinitionGroups().length > 0) {
      @for (group of taskDefinitionGroups(); let i = $index; track group.taskDefinitionId) {
        @if (group?.workflowStep?.id) {
          <mat-expansion-panel
            class="task-group"
            [disabled]="group.componentType === 'trigger' && disableTriggerEdit()"
            [expanded]="startExpanded()?.get(group.workflowStep?.id ?? '') || false"
          >
            <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
              <mat-panel-title>
                <automata-automation-node-icon
                  class="hide-xs"
                  [icon]="group?.icon ?? 'business'"
                  [iconColor]="group?.iconColor ?? 'primary'"
                  [iconMode]="'row'"
                  [enabled]="true"
                  [step]="group.workflowStep"
                  [hasError]="errors()?.get(group.workflowStep?.id ?? '') || false"
                >
                </automata-automation-node-icon>
                <div class="step-name-container">
                  <div
                    class="step-name"
                    [style.color]="
                      errors()?.get(group.workflowStep?.id ?? '') ? errorIconColor : (group?.iconColor ?? 'primary')
                    "
                  >
                    {{ stepNameMap()?.get(group.workflowStep?.id ?? '') }}
                  </div>
                  @if (displayNameMap()?.get(group.workflowStep?.id)) {
                    <span
                      class="action-name"
                      [innerHTML]="displayNameMap().get(group.workflowStep.id) | translate | iTrustThisHtml"
                    >
                    </span>
                  }
                </div>
                @if (group.componentType === 'trigger' && disableTriggerEdit()) {
                  <glxy-badge
                    class="badge-flex-end"
                    [tooltipTitle]="'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.TRIGGER_EDITING_DISABLED' | translate"
                    [glxyTooltip]="'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.TRIGGER_EDITING_DISABLED_TOOLTIP' | translate"
                    color="grey"
                  >
                    {{ 'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.READ_ONLY' | translate }}
                  </glxy-badge>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
            <automata-task-error-disclaimer
              [stepId]="group.workflowStep?.id"
              [isTrigger]="group.componentType === 'trigger'"
            ></automata-task-error-disclaimer>
            <ng-container #dynamicContainer></ng-container>
          </mat-expansion-panel>
        }
      }
      <mat-expansion-panel hideToggle disabled>
        <mat-expansion-panel-header class="editor-actions" [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
          <button mat-raised-button color="primary" (click)="collectDataAndEmit()">
            {{ 'AUTOMATIONS.EDITOR.SIMPLIFIED_EDITOR.SAVE_AUTOMATION' | translate }}
          </button>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    }
  </mat-accordion>

  <!-- Advanced Mode: Workflow Viewer Component -->
  @if (isAdvancedMode()) {
    <div class="workflow-viewer-container">
      <automata-automation-editor [automationId]="automation().id" [readOnly]="false"></automata-automation-editor>
    </div>
  }
</div>
